import { useState, useRef, useEffect } from "react";
const useDelayedState = (initialState, delay) => {
  const [value, setValue] = useState(initialState);
  const timer = useRef();
  const setDelayedValue = (newState) => {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setValue(newState), delay);
  };
  const setImmediateValue = (newState) => {
    clearTimeout(timer.current);
    setValue(newState);
  };
  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  return [value, setDelayedValue, setImmediateValue];
};
export {
  useDelayedState
};
//# sourceMappingURL=useDelayedState.js.map
